import { TLanguage } from '@cbo/shared-library';
import { RccLanguage } from '@ncr-voyix-commerce/react-common-components';

export function getStoredLang() {
  return localStorage.getItem('lang') ?? 'en-US';
}
export function setStoredLang(lang: string | undefined) {
  localStorage.setItem('lang', lang ?? 'en-US');
}

export const mapBSLLanguageToASMLanguage = (language: RccLanguage | undefined | null): TLanguage => {
  switch (language) {
    case 'en':
      return 'en-US';
    case 'es':
      return 'es-MX';
    case 'fr':
      return 'fr-CA';
    default:
      return 'en-US';
  }
};
